module.exports = __webpack_public_path__ + "img/logo-header.d27c58e9.png";